import type { PackageStateType } from './types';

export const kidsAgesDTO = (data: unknown): PackageStateType['kids_ages'] => {
  if (data && Array.isArray(data)) {
    return data.map((kidAge) => (typeof kidAge === 'number' ? kidAge : 0));
  }

  return [];
};
